/**
 * The tenant's Vapi SIP number (Prompt 3.4): Vapi agents answer phone calls on
 * Vapi only once it exists. Created in the tenant's own Vapi account.
 */
import { del, get, post } from '@core/api/client';
import { endpoints } from '@core/api/endpoints';

export interface VapiSipNumberStatus {
  engineEnabled: boolean;
  credentials: boolean;
  provisioned: boolean;
  phoneNumberId: string | null;
  sipUriMasked: string | null;
  createdAt: string | null;
}

export const vapiSipNumberService = {
  status(): Promise<VapiSipNumberStatus> {
    return get<VapiSipNumberStatus>(endpoints.telephony.vapiSipNumber);
  },
  ensure(): Promise<VapiSipNumberStatus> {
    return post<VapiSipNumberStatus>(endpoints.telephony.vapiSipNumber, {});
  },
  remove(): Promise<VapiSipNumberStatus> {
    return del<VapiSipNumberStatus>(endpoints.telephony.vapiSipNumber);
  },
};
